import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

interface NewDocumentAuditTrailFileResponse {
  url: string;
}

const convertToDeprecatedResponse = (
  response: NewDocumentAuditTrailFileResponse
): {
  result: {
    file: string;
  };
} => {
  return {
    result: {
      file: response.url,
    },
  };
};

/**
 *
 * @deprecated Endpoint path and response are modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#0249c7578e6d4ff5922d86698bc17e97
 */
// eslint-disable-next-line import/prefer-default-export
export function getDocumentsAuditTrailFile({
  documentId,
  workspaceId,
}: {
  documentId: string;
  workspaceId: string;
}): Promise<string> {
  return requestApi<NewDocumentAuditTrailFileResponse>({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/audit-trail`),
    method: 'GET',
    credentials: true,
  }).then((response) => convertToDeprecatedResponse(response.data).result.file);
}
